module.exports = __webpack_public_path__ + "static/media/Resume 2022 Bennett Oh.0fd8f874.pdf";